var _lenis;
if (typeof Lenis !== 'undefined') {
  _lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
    _lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function(time) { _lenis.raf(time * 1000); });
    gsap.ticker.lagSmoothing(0);

    var heroBg      = document.querySelector('[data-parallax-layer="bg"]');
    var heroText    = document.querySelector('[data-parallax-layer="text"]');
    var heroCard    = document.querySelector('[data-parallax-layer="card"]');
    var heroSection = document.querySelector('[data-parallax-hero]');

    if (heroBg && heroSection) {
      gsap.to(heroBg, {
        yPercent: 30, ease: 'none',
        scrollTrigger: { trigger: heroSection, start: 'top top', end: 'bottom top', scrub: true }
      });
    }
    if (heroText && heroSection) {
      gsap.to(heroText, {
        yPercent: 12, ease: 'none',
        scrollTrigger: { trigger: heroSection, start: 'top top', end: 'bottom top', scrub: true }
      });
    }
    if (heroCard && heroSection) {
      gsap.to(heroCard, {
        yPercent: 20, ease: 'none',
        scrollTrigger: { trigger: heroSection, start: 'top top', end: 'bottom top', scrub: true }
      });
    }
  } else {
    function raf(time) { _lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu toggle
  var burger = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      mobileMenu.classList.toggle('is-open');
      burger.classList.toggle('is-active');
    });
  }

  // Product image thumbnails (product page)
  var thumbs = document.querySelectorAll('[data-thumb]');
  var mainImage = document.querySelector('.product__image');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) mainImage.src = thumb.src.replace(/width=\d+/, 'width=1200');
    });
  });

  // Scroll reveal
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Header shrink on scroll
  var header = document.querySelector('[data-scroll-header]');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    });
  }

});
